import { render, staticRenderFns } from "./ImageGrid.vue?vue&type=template&id=6175897e&scoped=true&"
import script from "./ImageGrid.vue?vue&type=script&lang=ts&"
export * from "./ImageGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ImageGrid.vue?vue&type=style&index=0&id=6175897e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6175897e",
  null
  
)

export default component.exports